import { getDefaultTimezone } from './times'
import moment from 'moment-timezone'

const getDateLabel = (date, timezone, is24hrFormat) => {
  const format = is24hrFormat ? 'HH:mm' : 'h:mm A'
  return moment(date).tz(getDefaultTimezone(timezone)).format(`MM/DD ${format}`)
}

export default getDateLabel
